<!-- <div class="signin-sec">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 order-2 col-md-8 text-center order-md-1">
        <h1>Less paperwork, more insights.</h1>
        <div class="s-text"><b>See results right away.</b> <img src="./assets/images/L-icon.png" width="24px">
          Work smarter and get more time to <span>focus on what really matters.</span></div>
        <div class="row justify-content-center align-items-center Img-sec">
          <div class="col-6 col-md-4">
            <img src="./assets/images/3phones.png" class="img-fluid">
          </div>
          <div class="col-6 col-md-4 text-left">
            <div class="faster-text"><span class="t1">5</span> <span class="t2">X</span>Faster</div>
            <div style="padding-bottom: 10px;">“Our inspections and reporting time went down from 5h to 1h. Excellent
              app!“</div>
            <div>H&S Advisor</div>
            <img src="./assets/images/star.svg" height="23px">
            <div class="pt-10 app-store">
              <a href="https://apps.apple.com/us/app/goaudits/id1077350870" target=”_blank”> <img
                  src="./assets/images/ios.svg"></a>
              <a href="https://play.google.com/store/apps/details?id=com.goaudits.goaudits&hl=en" target=”_blank”> <img
                  src="./assets/images/android.svg"></a>
              <a href="https://app.goaudits.com/" target=”_blank”> <img src="./assets/images/webapp.svg"></a>
            </div>

          </div>
        </div>
      </div>
      <div class="col-12 order-1 col-md-4 text-center order-md-2">
        <div><a href="https://goaudits.com"><img src="./assets/images/logo.svg" height="50px"></a></div>
        <form class="login-box validate-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
              <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>Username</mat-label>
                <input matInput formControlName="username" />
                <mat-error
                  *ngIf="loginForm.get('username').invalid && (loginForm.get('username').touched || loginForm.get('username').dirty) && loginForm.get('username').errors.required">
                  Please enter email address</mat-error>
                <mat-error
                  *ngIf="loginForm.get('username').invalid && (loginForm.get('username').touched || loginForm.get('username').dirty) && loginForm.get('username').errors.email">
                  Please enter a valid email address</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12col-lg-12 col-md-12 col-sm-12 mb-2">
              <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>Password</mat-label>
                <input matInput formControlName="password" [type]="hide ? 'password' : 'text'">
                <mat-icon matSuffix (click)="hide = !hide" class="pwd" style="cursor: pointer;">
                  {{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                <mat-error
                  *ngIf="loginForm.get('password').invalid && (loginForm.get('password').touched || loginForm.get('password').dirty) && loginForm.get('password').errors.required">
                  Password is required</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="text-left">
            <a style="font-size: 12px;" class="txt1" routerLink="/authentication/forgot-password">Forgot Password?</a>
          </div>
          <div class="container-login100-form-btn mt-4" style="padding-bottom: 15px;">
            <button mat-flat-button color="primary" class="login-btn" type="submit" *ngIf="!isLoading">Login</button>
            <button mat-flat-button color="primary" class="login-btn" type="submit" *ngIf="isLoading">
              <i>Working, Please wait...</i></button>

              <div class="pt-3">
                <a (click)="onSsoLogin()" routerLink="/authentication/sso-login">
                  Sign in with Single Sign-On
                </a>
              </div>
            <mat-error *ngIf="showLogError && !locked" class="sign-error"><i
                class="fa fa-exclamation-triangle mr-2"></i>{{showLogError}}</mat-error>
            <mat-error *ngIf="locked" class="sign-error"><i class="fa fa-exclamation-triangle mr-2"></i>You account is
              currently locked due to many incorrect login attempts. Please reset <a class="txt1"
                routerLink="/authentication/forgot-password">here</a>. </mat-error>
          </div>
          <div class="text-center">

          </div>
        </form>
      </div>
    </div>
  </div>
</div> -->
<div class="signin-sec">

  <div class="container-fluid sign">
    <div class="row h-100">

      <div class="col-12 col-md-7 order-md-1 d-flex  justify-content-center align-items-center bg-white col-tab">
        <div class="box-size">
          <div class="logo">
            <a href="https://goaudits.com/" target="blank">
              <img src="./assets/images/logo.svg" height="50px">
            </a>
          </div>
          <div class="heading login-box w-100 ">  
            Login
          </div>
          <form class="login-box validate-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 dense-2">
                <mat-form-field class="example-full-width" appearance="outline" id="allign">
                  <mat-label>Email Address</mat-label>
                  <input matInput formControlName="username" autocomplete="off" required />
                  <mat-error 
                    *ngIf="loginForm.get('username').hasError('required') || loginForm.get('username').touched">
                    Please enter a valid email address
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12col-lg-12 col-md-12 col-sm-12 dense-2">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>Password</mat-label>
                  <input autocomplete="off" matInput type="password" formControlName="password"
                    [type]="hide ? 'password' : 'text'" maxlength="20" required>
                  <mat-icon matSuffix (click)="hide = !hide" class="pwd" style="cursor: pointer;">
                    {{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                  <mat-error  *ngIf="loginForm.get('password').hasError('required')">
                    Password is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>


            <div class="flex-sb-m w-full p-b-20">
              <div>
                <a class="txt1" routerLink="/authentication/forgot-password">Forgot Password?</a>
              </div>
            </div>
            <div class="">
              <button mat-raised-button color="primary" class="login-btn" type="submit"
                *ngIf="!isLoading">Login</button>
              <button mat-raised-button color="primary" class="login-btn" type="submit" *ngIf="isLoading">
                <i>Working, Please wait...</i></button>
              <!-- <mat-error *ngIf="msg && !locked" class="sign-error"><i class="fa fa-exclamation-triangle mr-2"></i>{{msg}}
              </mat-error> -->
              <mat-error  *ngIf="showLogError && !locked" class="sign-error"><i
                  class="fa fa-exclamation-triangle mr-2"></i>{{showLogError}}</mat-error>
              <mat-error  *ngIf="locked" class="sign-error"><i class="fa fa-exclamation-triangle mr-2"></i>
                You account is currently locked due to many incorrect login attempts. Please reset <a class="txt1"
                  routerLink="/authentication/forgot-password" style="color: green;">here</a>.
              </mat-error>
              <div class="d-flex flex-column  align-items-start">
                <button mat-raised-button color="" id="allign" class="signup-btn" type="submit"
                  (click)="onSsoLogin()">Sign in with Single Sign-On</button>
                <table>
                  <tr>
                    <td style="width:48%">
                      <hr />
                    </td>
                    <td style="vertical-align:middle; text-align: center; color: black;font-size: 13px">or</td>
                    <td style="width:48%">
                      <hr />
                    </td>
                  </tr>
                </table>
                <button mat-raised-button color="" id="allign" class="google-btn" type="button"
                  routerLinkActive="router-link-active" (click)="googlesignin()">
                  <i class='fab fa-google'></i> Continue with Google</button>
                  <button mat-raised-button color="" id="allign" class="google-btn" type="button"
                  routerLinkActive="router-link-active" (click)="microsignin()" style="margin-top: 1.5rem;">
                  <img src="./assets/images/microsoft.png" class="micrologo"> Continue with Microsoft</button>

                <a href="https://goaudits.com/book-demo/" target="_blank" style="width: 100%;">
                  <button mat-raised-button color="" id="allign" class="demo-btn-left" type="submit">BOOK A
                    DEMO</button></a>
                <button mat-raised-button color="" id="allign" class="signin-btn-left" type="button"
                  (click)="onSignUp()">Create a free trial account</button>
              </div>

            </div>

          </form>


          <!-- <div class="d-flex flex-column  align-items-start">
              <button mat-raised-button color="" id="allign" class="signup-btn" type="submit"
              (click)="onSsoLogin()">Sign in with Single Sign-On</button>
          </div> -->
        </div>
      </div>

      <div class="col-12 col-md-4 text-left order-md-2 right_section col-tab">
        <div class="heading-text">
          Don't have an account?
          <div class="d-flex flex-column gap-2 align-items-center">
            <a href="https://goaudits.com/book-demo/" target="_blank" style="width: 100%;">
              <button mat-raised-button color="" id="allign" class="demo-btn" type="submit">Book a demo</button></a>
            <button mat-raised-button color="" id="allign" class="signin-btn" type="submit" (click)="onSignUp()">Create
              a free trial account</button>
          </div>


        </div>
      </div>
    </div>
  </div>